<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

const props = defineProps({
  installment: { type: Object, required: true },
});

const { t } = useI18n();
const generatedAt = computed(() =>
  new Intl.DateTimeFormat('pt-BR', {
    day: 'numeric',
    month: 'long',
    weekday: 'long',
    year: 'numeric',
  }).format(new Date())
);
const address = computed(() => {
  const data = props.installment.dados_processo || {};
  const street = [data.logradouro, data.numero].filter(Boolean).join(', ');
  const details = [data.unidade, data.complemento].filter(Boolean).join(', ');
  const city = [data.cidade, data.uf].filter(Boolean).join(' - ');
  return [street, details, data.bairro, city].filter(Boolean).join(', ');
});
const saleDate = computed(() => {
  const value = props.installment.dados_processo?.data_assinatura;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) {
    return value || t('REAL_ESTATE_COMMISSION_INSTALLMENT.COMMON.NOT_INFORMED');
  }
  return new Intl.DateTimeFormat('pt-BR').format(new Date(`${value}T12:00:00`));
});
</script>

<template>
  <LaisCard
    :title="t('REAL_ESTATE_COMMISSION_INSTALLMENT.PREVIEW.TITLE')"
    prefix-icon="i-lucide-file-text"
  >
    <p class="mb-4 text-sm font-medium text-lais-text-muted">
      {{ generatedAt }}
    </p>
    <div class="grid gap-3 text-sm sm:grid-cols-2 xl:grid-cols-4">
      <div>
        <p class="text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.PREVIEW.STORE') }}
        </p>
        <p class="mt-1 font-semibold">
          {{ installment.dados_processo?.loja_name }}
        </p>
      </div>
      <div>
        <p class="text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.PREVIEW.SALE_DATE') }}
        </p>
        <p class="mt-1 font-semibold">{{ saleDate }}</p>
      </div>
      <div>
        <p class="text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.PREVIEW.REFERENCE') }}
        </p>
        <p class="mt-1 font-semibold">
          {{ installment.dados_processo?.codigo || installment.processo_id }}
        </p>
      </div>
      <div class="sm:col-span-2 xl:col-span-1">
        <p class="text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.PREVIEW.PROPERTY') }}
        </p>
        <p class="mt-1 font-semibold">
          {{
            address ||
            t('REAL_ESTATE_COMMISSION_INSTALLMENT.COMMON.NOT_INFORMED')
          }}
        </p>
      </div>
    </div>
  </LaisCard>
</template>
